import { useGetApiData } from "shared/datalayer";
import PublicApi from "shared/enums/PublicApi";
import { ApiRegistrationFormForRegListingByConsoleUser } from "shared/types/ApiRegistrationFormForRegListingByConsoleUser";

export function useFindEventAttendeeRegistrationFormsByRegistrationId({ registrationId }: { registrationId: string }) {
  return useGetApiData<Array<ApiRegistrationFormForRegListingByConsoleUser>>(
    PublicApi.FIND_EVENT_ATTENDEE_REGISTRATION_FORMS_BY_REGISTRATION_ID,
    { params: { registrationId } },
    { enabled: Boolean(registrationId) }
  );
}
